import React from 'react';
import { useTranslation } from 'react-i18next';
import { Factory, Users, Warehouse } from 'lucide-react';

export type EntityType = 'SUPPLIER' | 'CUSTOMER' | 'WAREHOUSE';

interface EntityTypeSelectorProps {
  value: EntityType;
  onChange: (type: EntityType) => void;
  disabled?: boolean;
}

export const EntityTypeSelector: React.FC<EntityTypeSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const { t } = useTranslation();

  const types: Array<{ value: EntityType; label: string; icon: React.ReactNode }> = [
    { value: 'SUPPLIER', label: t('entity.supplier'), icon: <Factory className="w-4 h-4" /> },
    { value: 'CUSTOMER', label: t('entity.customer'), icon: <Users className="w-4 h-4" /> },
    { value: 'WAREHOUSE', label: t('entity.warehouse'), icon: <Warehouse className="w-4 h-4" /> },
  ];

  return (
    <div className="mb-3">
      <label className="block text-sm font-medium mb-2">
        {t('trips.entityType')}
      </label>
      <div className="flex gap-2">
        {types.map((type) => (
          <button
            key={type.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(type.value)}
            className={`
              flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all
              ${value === type.value
                ? 'bg-primary-100 text-primary-700 border border-primary-300'
                : 'bg-gray-100 text-gray-600 border border-transparent hover:bg-gray-200'
              }
              ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            `}
          >
            {type.icon}
            {type.label}
          </button>
        ))}
      </div>
    </div>
  );
};
